import React from "react";
import Layout from "@ADC/components/Layout";
import Steps from "@ADC/components/Pages/404Page/Form/Steps";
import { Header, Footer } from "@ADC/components/Views";
import { Link } from "gatsby";

const Index = () => {
  return (
    <Layout className="w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden">
      <Header />
      <section className="py-10">
        <div className="container text-center">
          <h1 className="text-[8rem] font-bold text-green-700 leading-none">
            404
          </h1>
          <h4 className="text-4xl capitalize font-semibold text-sky-700 mb-6">
            page not found!
          </h4>
          <p className="text-lg">
            We apologize, but the page you're looking for cannot be found. It
            might be an error on our part, <br /> but we're aware of it and will
            work on resolving the issue. In the meantime, please try one of
            these options:
            <span className="mt-6 block text-sm font-semibold">
              <Link className="underline" to="/">
                Go To Homepage,
              </Link>{" "}
              Or
            </span>
          </p>
        </div>
      </section>
      <section className="grid grid-cols-1 md:grid-cols-[40%_60%] place-items-center">
        <img
          src="/images/CustomerServiceM3.jpg"
          className="h-auto object-cover max-md:hidden"
          alt="Customer Service"
        />
        <img
          src="/images/CustomerServiceM3lower.jpg"
          className="h-auto object-cover md:hidden"
          alt="Customer Service"
        />
        <div className="bg-custom-lightGray flex items-center h-full w-full">
          <div className="px-8 py-6 max-w-[640px]">
            <div className="relative">
              <h4 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-green-700">
                Have a chat with us.
              </h4>
              <p className="text-md lg:text-xl mt-3 mb-6">
                Call Now for a free, no-obligation consultation with a Texas
                Debt Specialist. Get a tailored solution to resolve overwhelming
                credit card and personal loan debt.
              </p>
              <a
                className="transition bg-green-700 hover:bg-green-800 px-16 text-white font-bold py-2 rounded border-radius-5"
                href="tel:8008161003"
              >
                800-816-1003
              </a>
            </div>
          </div>
        </div>
      </section>
      <Steps />
      <Footer />
    </Layout>
  );
};

export default Index;
